import React from 'react';
import { View, TouchableOpacity, Image } from 'react-native';
import MyAppText from '../MyAppText';
import { translate } from '../../services/translate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import { WindowInformation } from '../../services/window-information';
import { InfoInRow } from '../InfoInRow';
import { faCalendarCheck, faLocationDot, faTimes } from '@fortawesome/pro-regular-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import Card from '../Card';
import { RootNavigation } from '../../Routes';

export function MpMobileAgentPlateDetectedOccurrence({ occurrence, navigation }: { occurrence: Occurrence; navigation: RootNavigation; }) {
    const { styles, theme } = useStyles(styleSheet);
    const windowInfo = WindowInformation();

    if (!occurrence.resume) {
        return <></>;
    }
    const resume = occurrence.resume as MpMobileAgentPlateDetectedResumeData;

    return (
        <View style={{ gap: 20 }}>
            <View style={{ gap: 20 }}>
                <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                        <TouchableOpacity
                            onPress={() => {
                                window.open(`/dispatch/occurrences/detail/${occurrence?.id}`);
                            }}
                            disabled={windowInfo.isMobile}
                        >
                            <MyAppText style={{ fontSize: 16, color: theme.colors.textColor, fontWeight: 'bold' }}>
                                {translate('nProtocol')}: {occurrence?.id}
                            </MyAppText>
                        </TouchableOpacity>
                        <MyAppText> </MyAppText>
                        <MyAppText style={{ fontSize: 14, color: theme.colors.textColor }}>
                            ({translate('team')} {translate(occurrence.OccurrenceUnits?.length && occurrence.OccurrenceUnits[0].OccurrenceUnit.isStarter ? 'starter' : 'support').toLowerCase()})
                        </MyAppText>
                    </View>
                    <TouchableOpacity onPress={() => navigation.navigate('AppAgent', { screen: 'AgentOccurrences' })}>
                        <FontAwesomeIcon color={theme.colors.iconColor} fontSize={30} icon={faTimes as IconDefinition} />
                    </TouchableOpacity>
                </View>
                <MyAppText style={styles.alertText}>
                    {translate('mpMobileAgentPlateDetectedAlert')}:
                </MyAppText>
                <MyAppText style={styles.alertName}>{resume.plate}</MyAppText>
                <View style={styles.imageBox}>
                    <Image source={{ uri: resume.imageUrl }} style={styles.image} />
                </View>
            </View>
            <Card>
                <View style={{ gap: 3 }}>
                    <MyAppText style={styles.cardBoldText}>
                        {translate('vehicleData')}
                    </MyAppText>
                    <InfoInRow title={'model'} value={resume.modelBrand} />
                    <InfoInRow title={'color'} value={resume.color} />
                    <InfoInRow title={'modelYear'} value={resume.modelYear} />
                    <InfoInRow title={'manufacturingYear'} value={resume.manufacturingYear} />
                    <InfoInRow title={'chassis'} value={resume.chassis} />
                </View>
                <View style={{ gap: 3 }}>
                    <MyAppText style={styles.cardBoldText}>
                        {translate('visualizedOn')}
                    </MyAppText>
                    <InfoInRow value={resume.time} isDate={true} fontAwesomeIcon={faCalendarCheck} />
                    <InfoInRow value={`${resume.location} / ${resume.federativeUnit}`} fontAwesomeIcon={faLocationDot} />
                    <InfoInRow title={'city'} value={resume.city} />
                    <InfoInRow title={'federativeUnit'} value={resume.federativeUnit} />
                </View>
                <InfoInRow title={'description'} value={resume.occurrenceHistory} />
                <View style={{ gap: 3 }}>
                    <MyAppText style={styles.cardBoldText}>
                        {translate('systemData')}
                    </MyAppText>
                    <InfoInRow title={'natureOfOccurrence'} value={resume.natureOfOccurrence} />
                    <InfoInRow title={'policeReportNumber'} value={resume.policeReportNumber} />
                    <InfoInRow title={'policeReportYear'} value={resume.policeReportYear} />
                    <InfoInRow title={'policeReportLocation'} value={`${resume.policeReportMunicipality} / ${resume.policeReportFederativeUnit}`} />
                    <InfoInRow title={'occurrenceDate'} value={resume.occurrenceDate} isDate={true} />
                </View>
                <View>
                    <InfoInRow title={'priority'} valueStyle={occurrence.priority === 'maximum' ? { color: '#FF0027' } : undefined} value={occurrence.priority ? translate(occurrence.priority) : ''} />
                    <InfoInRow title={'narrative'} value={occurrence.narrative} />
                </View>
            </Card>
        </View>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    alertText: {
        color: theme.colors.textColor,
        fontSize: 16,
        fontWeight: 'bold',
    },
    cardBoldText: {
        color: theme.colors.textColor,
        fontWeight: 'bold',
        fontSize: 14
    },
    alertName: {
        color: theme.colors.textColor,
        fontSize: 18,
        fontWeight: 'bold',
    },
    imageBox: {
        height: 314,
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
    },
    image: {
        height: 314,
        width: 311,
        objectFit: 'contain',
        borderRadius: 8,
        resizeMode: 'contain',
        overflow: 'hidden',
    },
}));
